import { render, staticRenderFns } from "./FulfillmentMain.vue?vue&type=template&id=dc78b18a"
import script from "./FulfillmentMain.vue?vue&type=script&lang=js"
export * from "./FulfillmentMain.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentMain.vue?vue&type=style&index=0&id=dc78b18a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports